import { TCompanyOfficePayloadSchema } from 'modules/settings/models';
import API from 'services/api';

type TCompanyOfficePayload = {
  officeId?: string | null;
  payload: TCompanyOfficePayloadSchema;
};

export const upsertCompanyOffice = ({ officeId, payload }: TCompanyOfficePayload) => {
  if (!!officeId) {
    return API.put(`/api/offices/${officeId}`, payload);
  } else {
    return API.post('/api/offices', payload);
  }
};
